import { createContext, useContext, useEffect, useState } from "react";
import { getDictionary } from "../getDictionary";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [dictionary, setDictionary] = useState(null);
  const [lang, setLang] = useState("pg");
  const [loading, setLoading] = useState(true);

  const changeLanguage = async (selectedLang) => {
    setLoading(true);

    localStorage.setItem("lang", selectedLang);
    setLang(selectedLang); // ✅ keep state in sync

    const dict = await getDictionary(selectedLang);
    setDictionary(dict);

    setLoading(false);
  };

  useEffect(() => {
    const initLanguage = async () => {
      const savedLang = localStorage.getItem("lang") || "pg";

      // ✅ always sync localStorage
      localStorage.setItem("lang", savedLang);

      // ✅ IMPORTANT FIX (this was missing)
      setLang(savedLang);

      const dict = await getDictionary(savedLang);
      setDictionary(dict);

      setLoading(false);
    };

    initLanguage();
  }, []);

  return (
    <LanguageContext.Provider
      value={{ dictionary, lang, changeLanguage, loading }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);